import { forwardRef } from 'react'
import HCaptcha from '@hcaptcha/react-hcaptcha'

export const Captcha = forwardRef<HCaptcha>((_props, ref) => {
    const siteKey = import.meta.env.VITE_CAPTCHA_KEY
    return <HCaptcha sitekey={siteKey} ref={ref} size="invisible" />
})
